import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from '@/api/queries/auth';
import { getToken } from '@/lib/auth-storage';
import { Spinner } from '@/components/Spinner';

/**
 * Route guard:
 *
 * <ul>
 *   <li>Sem JWT → /login</li>
 *   <li>JWT + (needsOnboarding ou forcePasswordChange) e rota ≠ /onboarding → /onboarding</li>
 *   <li>Rota /onboarding mas nada pendente → /</li>
 * </ul>
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const token = getToken();
  const location = useLocation();
  const me = useMe(!!token);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (me.isLoading) {
    return (
      <main className="flex min-h-screen items-center justify-center p-4">
        <Spinner />
      </main>
    );
  }

  if (me.data) {
    const isOnboardingRoute = location.pathname.startsWith('/onboarding');
    const pendente = me.data.needsOnboarding || me.data.forcePasswordChange;

    if (pendente && !isOnboardingRoute) {
      return <Navigate to="/onboarding" replace />;
    }
    if (!pendente && isOnboardingRoute) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
